// extracted by mini-css-extract-plugin
export default {"sidebar-tabs":"lsf-sidebar-tabs","sidebar-tabs__toggle":"lsf-sidebar-tabs__toggle","sidebar-tabs__tab":"lsf-sidebar-tabs__tab","sidebar-tabs__tab_active":"lsf-sidebar-tabs__tab_active","sidebar-tabs__content":"lsf-sidebar-tabs__content"};
    if(module.hot) {
      // 1637785517385
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  